<script>
    import {Link} from "svelte-routing";

    export let href = '#';
</script>

<Link to={href} class="btn btn-link btn-icon" {...$$restProps}>
    <ion-icon name="create-outline" role="img" class="md hydrated" aria-label="edit"></ion-icon>
</Link>
